/* eslint-env browser */
import React, { useEffect, useState } from 'react';
import { last } from 'lodash/fp';
import { EVENTS } from 'constants/config';
import useEventListener from 'components/shared/hooks/useEventListener';

const LIST_SELECTOR = '.JourneyContentsList';
const STEP_NUMBER_SELECTOR =
  '.JourneyContentStep, .JourneyContentCollapsed-step';
const TIMEOUT_DELAY = 50;

function getAbsolutePosition(elem) {
  const rect = elem.getBoundingClientRect();
  const { body } = document;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  return {
    top: rect.top + scrollTop - clientTop,
    height: rect.height,
  };
}

const StepIndicatorConnector = () => {
  const [top, setTop] = useState(0);
  const [bottom, setBottom] = useState(null);
  const [completedConnectors] = useState([]);

  let timerId = null;

  const setPosition = () => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      const steps = document.querySelectorAll(STEP_NUMBER_SELECTOR);
      const list = document.querySelector(LIST_SELECTOR);

      if (steps.length <= 1) {
        setTop(0);
        setBottom(null);
      } else if (steps.length > 1) {
        const lastStepRect = getAbsolutePosition(last(steps));
        const listRect = getAbsolutePosition(list);

        setTop(steps[0].offsetTop);
        setBottom(listRect.height - lastStepRect.top + listRect.top - 1);
      }
    }, TIMEOUT_DELAY);
  };

  useEffect(() => {
    global.pubsub.subscribe(EVENTS.SET_STEP_CONNECTOR_POSITION, setPosition);

    setPosition();

    return () => {
      global.pubsub.unsubscribe(
        EVENTS.SET_STEP_CONNECTOR_POSITION,
        setPosition,
      );
      window.removeEventListener('resize', setPosition);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEventListener('resize', setPosition);

  return (
    <>
      {Object.values(completedConnectors).map(connector => (
        <div
          key={connector.key}
          className="JourneyStepsConnector JourneyStepsConnector--dashed"
          style={{ top: connector.top, height: connector.height }}
        />
      ))}
      <div className="JourneyStepsConnector" style={{ top, bottom }} />
    </>
  );
};

export default StepIndicatorConnector;
